import {
  BankAccount,
  useBankAccounts,
  getAccountNumber,
} from "@/api/bank-accounts"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface BankAccountSelectProps {
  defaultValue?: string;
  onChange: (bankAccountId: string) => void;
  disabled?: (bankAccount: BankAccount) => boolean;
}

export default function BankAccountSelect({
  onChange,
  defaultValue,
  disabled = () => false,
}: BankAccountSelectProps) {
  const { bankAccounts } = useBankAccounts()

  return (
    <Select
      disabled={!bankAccounts}
      onValueChange={onChange}
      defaultValue={defaultValue}
    >
      <SelectTrigger>
        <SelectValue
          placeholder={!bankAccounts ? "Loading..." : "Select bank account"}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {bankAccounts &&
            bankAccounts.map((bankAccount) => (
              <SelectItem
                key={bankAccount.id}
                value={bankAccount.id}
                disabled={disabled(bankAccount)}
              >
                {bankAccount.bankName} - {getAccountNumber(bankAccount)}
              </SelectItem>
            ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
